import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IPaperType } from "./routeType";

const { key, getPath } = getApi("types.paper.getAll");

type IExtractedRouteType = IPaperType["PaperSourceTypeCollectionRetrieve"];

export type IGetPaperType = IPickCollectionQuery<IExtractedRouteType>;

const getPaperSourceType: Fetcher<
  IGetPaperType["response"],
  IGetPaperType["variables"]
> = (params) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetPaperType = createQuery({
  queryKey: [key],
  fetcher: getPaperSourceType,
});
